export default "__VITE_PUBLIC_ASSET__6ca847b6__"